<template>
    <b-dropdown
      variant="primary"
      class="mt-4 btngroup-menu-dropdown d-block d-lg-none text-center"
      right
      text="Menu"
    >
      <b-dropdown-item v-b-modal.whats-new>
        🎉 See What's New
      </b-dropdown-item>
      <b-dropdown-divider></b-dropdown-divider>
      <b-dropdown-item href="https://www.patreon.com/rlcustomdesigns" target="_blank">
        <img src="@/assets/img/icons/patreon.svg" alt="Patreon" width="16" height="16" class="" style="margin-top: -3px;"> 
        Become a Patron
      </b-dropdown-item>
      <b-dropdown-item href="https://paypal.me/rlcustomdesigns" target="_blank">
        <img src="@/assets/img/icons/paypal.svg" alt="PayPal" width="16" height="16" class="" style="margin-top: -3px;"> 
        Donate via PayPal
      </b-dropdown-item>
      <b-dropdown-item href="https://www.buymeacoffee.com/rlcustomdesigns" target="_blank">
        ☕️ Buy Us a Coffee
      </b-dropdown-item>
      <b-dropdown-divider></b-dropdown-divider>
      <b-dropdown-item href="https://www.reddit.com/r/rlcustomdesigns/wiki/index" target="_blank">
        ❓ Read the FAQ
      </b-dropdown-item>
      <b-dropdown-item href="https://discord.gg/H3Cypr3" target="_blank">
        <img src="@/assets/img/icons/discord-circle.svg" alt="Discord" width="16" height="16" class="" style="margin-top: -3px;"> 
        Message us on Discord
      </b-dropdown-item>
      <b-dropdown-item href="https://www.reddit.com/message/compose/?to=/r/RLCustomDesigns" target="_blank">
        <img src="@/assets/img/icons/reddit-circle.svg" alt="Reddit" width="16" height="16" class="" style="margin-top: -3px;"> 
        Message us on Reddit
      </b-dropdown-item>
    </b-dropdown>
</template>

<script>

export default {
  name: 'MobileMenu',
  data() {
    return {
    }
  },
  props: {
  },
  components: {
  },
  methods: {
  }
}
</script>